/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DashboardAssetList,
} from '../models';
import {
    DashboardAssetListFromJSON,
    DashboardAssetListToJSON,
} from '../models';

export interface DashboardSmAssetsGetRequest {
    organizationId?: string;
}

/**
 * 
 */
export class DashboardAssetsApi extends runtime.BaseAPI {

    /**
     * List asset overview
     */
    async dashboardSmAssetsGetRaw(requestParameters: DashboardSmAssetsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardAssetList>> {
        const queryParameters: any = {};

        if (requestParameters.organizationId !== undefined) {
            queryParameters['organizationId'] = requestParameters.organizationId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/dashboard/sm/assets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardAssetListFromJSON(jsonValue));
    }

    /**
     * List asset overview
     */
    async dashboardSmAssetsGet(organizationId?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardAssetList> {
        const response = await this.dashboardSmAssetsGetRaw({ organizationId: organizationId }, initOverrides);
        return await response.value();
    }

}
